import { jsx as _jsx } from "react/jsx-runtime";
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import { useFeatureFlagsLoading } from '../hooks/useFeatureFlagsLoading';
export function withFeatureFlags(WrappedComponent) {
    return (props) => (_jsx(WithFeatureFlagsComponent, { WrappedComponent: WrappedComponent, componentProps: props }));
}
function WithFeatureFlagsComponent({ WrappedComponent, componentProps }) {
    const flags = useFeatureFlags();
    const loading = useFeatureFlagsLoading();
    return (_jsx(WrappedComponent, { flags: flags, loading: loading, ...componentProps }));
}
